<div class="helper-container">
  <div class="button-back-container">
    <ion-col size="3">
      <app-back-button
        (clicked)="handleVolverButton()"
        [isDisabled]="isSubscriptionButtonDisabled()"
        [text]="'Volver'"
      >
      </app-back-button>
    </ion-col>
  </div>

  <ion-grid>
    <ion-row class="ion-justify-content-between ion-nowrap">
      <div class="title-helper ion-align-items-center">Confirma los datos</div>
    </ion-row>
    <ion-row class="mt-16">
      <ion-col size="12">
        <div class="helper-subtitle">
          Verifica que tu modificación esté correcta
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="mt-24">
      <ion-col size="6">
        <ion-label class="apv-text modify-text-subtitle-3"
          >Datos de modificación:</ion-label
        >
      </ion-col>
      <ion-col size="6">
        <div class="modify-button-div-helper">
          <span class="modify-button-container">
            <ion-button
              class="modify-button"
              (click)="handleVolverButton()"
              (keypress)="true"
              [disabled]="isSubscriptionButtonDisabled()"
              [class.on-focus-button-secondary]="onFocusEditar"
              (ionFocus)="setFocusButtonEditar()"
              (ionBlur)="setFocusButtonEditar()"
            >
              Editar
            </ion-button>
          </span>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="mt-16">
      <ion-col size="6">
        <ion-label class="confirmation-text-col font-weight-500"
          >Nuevo monto de ahorro:</ion-label
        >
      </ion-col>
      <ion-col size="6">
        <ion-label class="confirmation-text-col">{{
          currencyByAmountAndCurrency(newAmount, this.newDiscount)
        }}</ion-label>
      </ion-col>
    </ion-row>
    <ion-row class="mt-16">
      <ion-col size="6">
        <ion-label class="confirmation-text-col font-weight-500"
          >Monto anterior:</ion-label
        >
      </ion-col>
      <ion-col size="6">
        <ion-label class="confirmation-text-col">{{
          currencyByAmountAndCurrencyCode(
            subscriptionDataToModify.discountValue,
            subscriptionDataToModify.discountType
          )
        }}</ion-label>
      </ion-col>
    </ion-row>
    <ion-row class="mt-16">
      <ion-col size="6">
        <ion-label class="confirmation-text-col font-weight-500"
          >Correo de tu empleador:</ion-label
        >
      </ion-col>
      <ion-col
        size="6"
        class="confirmation-text-col"
        style="word-wrap: break-word"
      >
        {{ employerMail }}
      </ion-col>
    </ion-row>
    <ion-row
      class="container-buttons-modal ion-justify-content-between ion-wrap-reverse mt-16"
    >
      <ion-button
        class="cancel-subscription-button ion-justify-content-center"
        (click)="salir()"
        (keypress)="true"
        [class.on-focus-button-secondary]="onFocusSalir"
        [disabled]="isSubscriptionButtonDisabled()"
        (ionFocus)="setFocusButtonSalir()"
        (ionBlur)="setFocusButtonSalir()"
        >Salir</ion-button
      >
      <ion-button
        class="continue-subscription-button ion-no-margin ion-no-padding"
        [class]="classBySubscriptionStatus()"
        [disabled]="isSubscriptionButtonDisabled()"
        (click)="submitModifySubscription()"
        (keypress)="true"
        id="modal-modificar-confirmar-button"
      >
        <ion-label> Confirmar </ion-label>
        <ion-spinner
          class="ml-24"
          name="circular"
          slot="end"
          color="ffffffff"
          *ngIf="showSpinner"
        >
        </ion-spinner>
      </ion-button>
    </ion-row>
  </ion-grid>
</div>
